import React, { useState } from "react";
import { FaPen, FaTrash } from "react-icons/fa"; // Import icons
import ConfirmationModal from "./ConfirmationModal"; // Import your ConfirmationModal component
import { supabase } from "../supabaseClient";

const AdditionalInfoForm = ({
  profileData,
  section,
  additionalInfo,
  onSave,
  onCancel,
  session,
}) => {
  const [editedInfo, setEditedInfo] = useState(additionalInfo);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value.split(", "), // Split by comma for skills and languages
    }));
  };

  const handleSave = async () => {
    const user_id = session.user.id; // Access user_id from session
    console.log("Edited AdditionalInfo variable = ", editedInfo);

    // Prepare the updated additionalInfo object
    const updatedExperiences = {
      ...profileData, // Spread the existing additionalInfo
      additional_information: editedInfo, // Update the specific section being edited
    };
    console.log("Updated variable = ", updatedExperiences);
    const { data, error } = await supabase
      .from("resumeUploaded")
      .update({ experiences: updatedExperiences })
      .eq("id", user_id);

    if (error) {
      console.error("Error updating additional information:", error.message);
    } else {
      onSave(editedInfo);
      window.location.reload(); // Reload the page after saving
    }
  };

  return (
    <div>
      {section && (
        <div className="mb-4">
          <label
            htmlFor={section}
            className="block text-gray-700 dark:text-gray-400"
          >
            {section} (comma separated)
          </label>
          <input
            type="text"
            id={section}
            name={section}
            value={editedInfo[section] ? editedInfo[section].join(", ") : ""}
            onChange={handleInputChange}
            className="input input-bordered w-full"
          />
        </div>
      )}
      <div className="flex justify-end">
        <button
          className="btn bg-purple-700 mr-2 text-blue-gray-50"
          onClick={handleSave}
        >
          Save
        </button>
        <button className="btn btn-outline" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};

const AdditionalInfo = ({ profileData, session, onSave }) => {
  const [isEditing, setIsEditing] = useState(null); // Track which section is being edited
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const [itemToDelete, setItemToDelete] = useState(null); // Track which item is to be deleted
  const [additionalInfo, setAdditionalInfo] = useState(
    profileData.additional_information
  );

  const handleSave = (updatedInfo) => {
    onSave(updatedInfo);
    setIsEditing(null); // Reset editing section after saving
  };

  const handleDelete = (key) => {
    // Logic to delete the specific key from additionalInfo
    console.log(`Delete ${key}`);
    // Here you would implement the actual deletion logic
    setIsModalOpen(false); // Close the modal after deletion
  };

  const openDeleteModal = (key) => {
    setItemToDelete(key); // Set the item to delete
    setIsModalOpen(true); // Open the confirmation modal
  };

  // Start mapping at the beginning of the return statement
  const infoSections = Object.keys(additionalInfo).map((key) => (
    <div key={key} className="mb-4">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">{key}</h3>
        <div className="flex items-center">
          <FaPen
            className="cursor-pointer text-purple-700 mr-2"
            onClick={() => setIsEditing(key)} // Set editing section to the current key
          />
          <FaTrash
            className="cursor-pointer text-purple-700"
            onClick={() => openDeleteModal(key)} // Open delete confirmation modal
          />
        </div>
      </div>
      {isEditing === key ? (
        <AdditionalInfoForm
          profileData={profileData}
          additionalInfo={additionalInfo}
          onSave={handleSave}
          onCancel={() => setIsEditing(null)} // Reset editing section on cancel
          section={key} // Pass the current section being edited
          session={session}
        />
      ) : (
        <p>{additionalInfo[key].join(", ")}</p>
      )}
    </div>
  ));

  return (
    <div className="card bg-base-100 shadow-lg rounded-lg overflow-hidden mb-6">
      <div className="card-body text-left">
        <h2 className="card-title dark:text-white">Additional Information</h2>
        <hr className="border-gray-200 border dark:border-gray-600 my-2" />
        <div>{infoSections}</div> {/* Render the mapped sections here */}
      </div>
      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={() => handleDelete(itemToDelete)} // Call the handleDelete function
        message={`Are you sure you want to delete this ${itemToDelete}?`}
      />
    </div>
  );
};

export default AdditionalInfo;
